import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:5001/api',
    baseURL: 'https://lmsapi.nitisolutions.com/api',
    // baseURL: 'http://192.168.1.253:5001/api'
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-auth-token'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
